import React from "react";
import { Image } from "expo-image";

export type IntegrationLogoType =
  | "bokaklipp"
  | "brandwatch"
  | "flourish"
  | "microsoft"
  | "pushappy"
  | "quinyx"
  | "tiltid"
  | "tomra"
  | "tooeasy"
  | "turnpike"
  | "upshop"
  | "softone";

export function IntegrationLogo(props: { type: IntegrationLogoType }) {
  function getSource() {
    switch (props.type) {
      case "bokaklipp":
        return require("./BokaklippLogo.webp");
      case "brandwatch":
        return require("./BrandwatchLogo.svg");
      case "flourish":
        return require("./FlourishLogo.webp");
      case "microsoft":
        return require("./MicrosoftLogo.png");
      case "pushappy":
        return require("./PushAppyLogoBlack.png");
      case "quinyx":
        return require("./quinyx-logo.svg");
      case "tiltid":
        return require("./tiltid.svg");
      case "tomra":
        return require("./TomraLogo.webp");
      case "tooeasy":
        return require("./TooEasy.svg");
      case "turnpike":
        return require("./TurnpikeLogo.png");
      case "upshop":
        return require("./Upshop.svg");
      case "softone":
        return require("./softone-logo.png");
      default:
        return null;
    }
  }

  return (
    <Image
      style={{ flex: 1 }}
      contentFit="contain"
      contentPosition="left center"
      source={getSource()}
    />
  );
}
